import "core-js/modules/es.array.push.js";
import { reactive, ref } from "vue";
import ExamBox from "@/components/ExamBox.vue";
import { ElMessage, ElLoading } from "element-plus";
import { getTimeText } from "@/assets/js/tool";
import { SearchExamsApi, GetExamListApi } from "@/api/examList.js";
export default {
  name: "ExamList",
  components: {
    ExamBox
  },
  setup() {
    let examList = reactive([[], [], []]);
    let examLoading = ref(false);
    //时间选择器
    let datePicker = ref([]);
    //考试状态
    let examStatusCon = ref(0);
    //切换目录
    function handleSelect(data) {
      examStatusCon.value = data;
    }
    //更新列表
    function getExamList() {
      let loading = ElLoading.service({
        lock: true,
        text: "加载中..",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let paras = {
        userIdCon: window.localStorage.getItem("fltrp-home-userId")
      };
      GetExamListApi({
        ...paras
      }).then(r => {
        loading.close();
        if (r.status < 400) {
          paras = {
            idsCon: []
          };
          let examStatusList = {};
          for (let i = 0; i < r.data.length; i++) {
            paras.idsCon.push(r.data[i]["examId"]);
            examStatusList[r.data[i]["examId"]] = r.data[i];
          }
          if (datePicker.value && datePicker.value[0]) {
            paras.endTimeQB = getTimeText(datePicker.value[0], false) + " 00:00:00";
          }
          if (datePicker.value && datePicker.value[1]) {
            paras.beginTimeQE = getTimeText(datePicker.value[1], false) + " 23:59:59";
          }
          if (paras.idsCon.length == 0) {
            examLoading.value = true;
            return 0;
          }
          loading = ElLoading.service({
            lock: true,
            text: "加载中..",
            background: "rgba(0, 0, 0, 0.7)"
          });
          SearchExamsApi({
            ...paras
          }).then(rs => {
            loading.close();
            examLoading.value = true;
            if (rs.status < 400) {
              examList[0] = [];
              examList[1] = [];
              examList[2] = [];
              for (let i = 0; i < rs.data.length; i++) {
                let exam = rs.data[i];
                if (!exam) {
                  continue;
                }
                exam["status"] = examStatusList[exam.id].status;
                exam["examName"] = exam.name;
                exam["beginDate"] = exam.beginTime;
                exam["endDate"] = exam.endTime;
                exam["publisherName"] = exam.createrLabel;
                exam["totalTime"] = examStatusList[exam.id].totalTime;
                exam["nextExam"] = examStatusList[exam.id].nextExam;
                exam["userId"] = examStatusList[exam.id].userId;
                exam["remainingTime"] = examStatusList[exam.id].remainingTime;
                if (exam.examType == 19) {
                  exam.skill = "S9";
                } else if (exam.examType == 17 || exam.examType == 23) {
                  exam.skill = exam.skills[0];
                } else if (exam.examType == 3) {
                  if (exam.skills[0] == "S0") {
                    exam.skill = "S9";
                  } else if (exam.skills[0] == "S5" || exam.papers.length == 1) {
                    exam.skill = exam.skills[0];
                  } else if (exam.skills[0] == "S4" || exam.papers.length <= 2) {
                    exam.skill = exam.skills[0];
                  } else {
                    exam.skill = "S9";
                  }
                }
                if (77 % exam["status"] === 0) {
                  examList[1].push(exam);
                } else if (exam.endTime < new Date().getTime() || exam.useable == -1) {
                  examList[2].push(exam);
                } else if (exam.useable == 1) {
                  examList[0].push(exam);
                }
              }
            }
          });
        } else {
          ElMessage({
            type: "error",
            showClose: true,
            message: r.msg
          });
        }
      });
    }
    //选择时间
    getExamList();
    return {
      examLoading,
      datePicker,
      examList,
      handleSelect,
      getExamList,
      examStatusCon
    };
  }
};